// extracted by mini-css-extract-plugin
export default {"modalOverlay":"modalArticleForm_modalOverlay__S9So-","modalContent":"modalArticleForm_modalContent__qeAYR"};